module.exports = __webpack_public_path__ + "img/DE00566.263afc9e.png";